<template>
  <div>
    <h3
      :class="{
        semibold: weight === 'semibold',
        light: weight === 'light',
        'mb-4': description
      }"
    >
      {{ label }}
      <slot />
    </h3>
    <doe-paragraph v-if="description" :description="description" />
  </div>
</template>

<script>
import DoeParagraph from "@/components/typography/Paragraph";

export default {
  name: "DoeFieldsetHeading",
  props: {
    label: {
      type: String,
      required: false
    },
    description: {
      type: [Array, String],
      required: false
    },
    weight: {
      type: String,
      default: "semibold",
      validator: value => {
        return ["semibold", "light"].indexOf(value) !== -1;
      }
    }
  },
  components: {
    DoeParagraph
  }
};
</script>

<style lang="scss" scoped>
h3 {
  @apply block font-sans font-semibold leading-snug subpixel-antialiased text-2xl text-blue-900;
}
h3.light {
  @apply font-light;
}
@screen lg {
  h3 {
    @apply leading-snug text-2xl;
  }
}
</style>
